import * as React from "react";

const SvgIcnTwilio = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <g fill="currentColor">
                <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c5.524 0 10-4.477 10-10S17.524 2 12 2m0 17.365a7.365 7.365 0 11.001-14.73A7.365 7.365 0 0112 19.365" />
                <path d="M12.625 9.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M12.625 14.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M7.625 14.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M7.625 9.5a2.083 2.083 0 114.167 0 2.083 2.083 0 01-4.167 0" />
            </g>
        </g>
    </svg>
);

export default SvgIcnTwilio;
